import React from 'react';
import type { Vendor } from '../../lib/types';
import { inp, MsgBox } from './shared';

interface Props {
  vendors: Vendor[];
  vendorsLoading: boolean;
  newVendorName: string; setNewVendorName: (s: string) => void;
  newVendorDomain: string; setNewVendorDomain: (s: string) => void;
  vendorBusy: boolean;
  vendorMsg: string;
  onAdd: () => void;
  onToggle: (id: string, currentEnabled: boolean) => void;
}

export function SettingsVendors(p: Props) {
  return (
    <div style={{ animation: 'fadeSlideIn .25s ease-out' }}>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>Vendors</div>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>Vendors added here are shared with the Chrome extension across your organisation.</div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
        <input value={p.newVendorName} onChange={e => p.setNewVendorName(e.target.value)} placeholder="Vendor name *" style={{ ...inp, flex: 1 }} />
        <input
          value={p.newVendorDomain}
          onChange={e => p.setNewVendorDomain(e.target.value)}
          placeholder="Domain (e.g. nzsafety.co.nz)"
          style={{ ...inp, flex: 1 }}
          onKeyDown={e => { if (e.key === 'Enter') p.onAdd(); }}
        />
        <button className="hbtn acc" disabled={p.vendorBusy || !p.newVendorName.trim() || !p.newVendorDomain.trim()} onClick={p.onAdd}
          style={{ borderRadius: 8, padding: '8px 14px', fontSize: 12, whiteSpace: 'nowrap' }}>+ Add</button>
      </div>
      <div style={{ fontSize: 10, color: 'var(--text3)', marginBottom: 10 }}>No https:// needed</div>
      <MsgBox msg={p.vendorMsg} />

      {p.vendorsLoading ? (
        <div style={{ color: 'var(--text3)', fontSize: 12, textAlign: 'center', padding: '20px 0' }}>Loading vendors...</div>
      ) : p.vendors.length === 0 ? (
        <div style={{ color: 'var(--text3)', fontSize: 12, textAlign: 'center', padding: '20px 0' }}>No vendors yet</div>
      ) : p.vendors.map(v => (
        <div key={v.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--border)', gap: 8 }}>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.name}</div>
            <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 1 }}>{v.domain}</div>
          </div>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
            <button onClick={() => p.onToggle(v.id, v.enabled)}
              style={{ background: 'none', border: '1px solid var(--border)', color: v.enabled ? 'var(--accent)' : 'var(--text3)',
                padding: '3px 8px', borderRadius: 6, cursor: 'pointer', fontSize: 10, fontFamily: 'var(--font)' }}>
              {v.enabled ? 'Active' : 'Disabled'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
